import { useContext, useState } from "react";
import { Flex, Segmented } from "antd";
import {
	AppstoreOutlined,
	CheckCircleOutlined,
	PauseCircleOutlined,
	StopOutlined,
} from "@ant-design/icons";
import trans from "../../utils";
import Searchbar from "../Helpers/Searchbar/Searchbar";
import { filtrationcontext } from "../../context/Filtercontext";

export default function RecurringPlannersHeader({
	statusFilter,
	setStatusFilter,
}) {
	const { setSearchQuery } = useContext(filtrationcontext);
	const [query, setQuery] = useState("");

	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};

	return (
		<div className="bg-white p-4">
			<Flex
				vertical={false}
				align="center"
				justify="space-between"
				gap="middle"
			>
				<Flex style={{ flex: 1 }} align="center">
					<Searchbar
						placeholder={trans("Search")}
						value={query}
						onChange={handleSearch}
					/>
				</Flex>
				<Flex vertical={false} gap={"small"}>
					<Segmented
						options={[
							{
								label: trans("All"),
								value: "",
								icon: <AppstoreOutlined />,
							},
							{
								label: trans("Active"),
								value: "ACTIVE",
								icon: <CheckCircleOutlined />,
							},
							{
								label: trans("Paused"),
								value: "PAUSED",
								icon: <PauseCircleOutlined />,
							},
							{
								label: trans("Cancelled"),
								value: "CANCELLED",
								icon: <StopOutlined />,
							},
						]}
						value={statusFilter}
						onChange={setStatusFilter}
					/>
				</Flex>
			</Flex>
		</div>
	);
}
